module.exports = "<h2 class=\"dash-header\" hide-xs>\n  <span>Workforce</span>\n</h2>\n"